import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material';

import Router from 'router/Router';
import { usePageReloadOnFocus } from 'hooks/usePageReloadOnFocus';
import { Notifications } from 'components/complex/Notifications';
import { theme } from 'muiTheme/theme';

import store from './store';

import './assets/fonts/fonts.css';

const App = () => {
  usePageReloadOnFocus();

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <Router />
        <Notifications />
      </ThemeProvider>
    </Provider>
  );
};

export default App;
